module.exports = __webpack_public_path__ + "back_top.a863c4b2.png";